"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextField = void 0;
/* eslint-disable react/display-name */
const react_1 = __importDefault(require("react"));
require("./TextField.scss");
const TextField_scss_json_1 = __importDefault(require("./TextField.scss.json"));
const Input_1 = require("@mui/base/Input");
const ClassNames_1 = require("lincd/lib/utils/ClassNames");
exports.TextField = react_1.default.forwardRef(function (_a, ref) {
    var { error, className, helperText } = _a, props = __rest(_a, ["error", "className", "helperText"]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Input_1.Input, Object.assign({}, props, { ref: ref, className: (0, ClassNames_1.cl)(TextField_scss_json_1.default.TextField, className, error && TextField_scss_json_1.default.error) })),
        helperText && react_1.default.createElement("p", { className: TextField_scss_json_1.default.helperText }, helperText)));
});
//# sourceMappingURL=TextField.js.map